<template>
  <section v-if="loading">
    <loading />
  </section>
  <section class="termo-aceite" v-else>
    <h4 class="h4 color-blue font-weight-bold">Aceite do Termo Aditivo</h4>
    <Aceite
      :voltar="voltar"
      :action-aceite="true"
      :linkVoltar="'/produto/clube-vantagens/painel'"
      @click="salvarAceite"
      :file="file"
      :aceite="aceite"
      :loading="loadingSave"
      :strLoading="'Aguarde, salvando termo'"
    />
    <div class="py-5"></div>
  </section>
</template>
<script>
import Aceite from "@/components/aceite/Aceite.vue";
export default {
  name: "TermoAceite",
  components: {
    Aceite,
  },
  props: {
    cpfTitular: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      produto: {
        nome: "Clube de Vantagens",
        id: "Clube de Vantagens",
      },
      breadcrumb: [
        {
          nome: "Clube de Vantagens",
          id: "Clube de Vantagens",
          link: "/produto/clube-vantagens/painel",
        },
        {
          nome: "Termo de Aceite",
          id: "termoAceite",
          produto: "Clube de Vantagens",
        },
      ],
      voltar: true,
      loading: false,
      linkVoltar: "#",
      linkAceite: "#",
      aceite: "Estou de acordo com o termo acima.",
      file: null,
      tipoReserva: null,
      loadingSave: false,
      eventoId: null,
      rotaVotar: null,
      paramsRota: {},
    };
  },
  methods: {
    async salvarAceite(payload) {
      this.loadingSave = true;
      this.$emit("click", {
        checkAceite: payload.checkAceite,
      });

      if (!sessionStorage.ip) {
        await fetch(process.env.VUE_APP_IP_API + "?format=json")
          .then((x) => x.json())
          .then(({ ip }) => {
            sessionStorage.ip = ip;
          });
      }

      let d = new Date();
      let date = new Date(d.valueOf() - d.getTimezoneOffset() * 60000);

      const dadosTermo = {
        dtVersao: date,
        dtAceite: date,
        ipOrigem: sessionStorage.ip,
        browserData: navigator.appVersion,
      };

      await this.$http
        .post("/api/Clube/AceitarTermoClubeVantagens", dadosTermo)
        .then((response) => {
          if (response.status === 200) {
            this.$router.push({ name: "clube-painel" });
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$router.push({ name: "login" });
          }
          console.error(error);
          this.$toast.open({
            message: "Erro ao assinar o termo, tente novamente.",
            type: "error",
          });
          this.loading = false;
        });
    },
  },
  async created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.loading = false;

    // Monta a rota para o botão voltar
    this.rotaVotar = "agenda";

    this.$http
      .get("/api/Clube/BuscarTermoClubeVantagens")
      .then((response) => {
        this.file = `data:application/pdf; base64, ${response.data.file.fileContents}`;
        this.loading = false;
      })
      .catch((error) => {
        if (error.response.status === 401) {
          this.$router.push({ name: "login" });
        }
        if (error.response.status === 400) {
          this.$toast.open({
            message: error.response.data.mensagem,
            type: "warning",
          });
          this.$router.push({ name: "agenda" });
        }
        this.loading = false;
      });
  },
};
</script>
